var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearCartDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.599 12.9136C16.3933 12.9136 16.2267 13.0802 16.2267 13.2859V20.3224C16.2267 20.5279 16.3933 20.6948 16.599 20.6948C16.8046 20.6948 16.9713 20.5279 16.9713 20.3224V13.2859C16.9713 13.0802 16.8046 12.9136 16.599 12.9136Z",
    fill: "#FF5252",
    stroke: "#FF5252",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7993 12.9136C13.5936 12.9136 13.427 13.0802 13.427 13.2859V20.3224C13.427 20.5279 13.5936 20.6948 13.7993 20.6948C14.0049 20.6948 14.1716 20.5279 14.1716 20.3224V13.2859C14.1716 13.0802 14.0049 12.9136 13.7993 12.9136Z",
    fill: "#FF5252",
    stroke: "#FF5252",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.801 11.8866V21.0594C9.801 21.6016 9.9998 22.1107 10.3471 22.4761C10.6928 22.8424 11.1739 23.0504 11.6774 23.0512H18.7215C19.2251 23.0504 19.7062 22.8424 20.0517 22.4761C20.399 22.1107 20.5978 21.6016 20.5978 21.0594V11.8866C21.2882 11.7034 21.7355 11.0364 21.6432 10.328C21.5507 9.61979 20.9473 9.08998 20.2329 9.08984H18.3268V8.62446C18.3289 8.2331 18.1742 7.85731 17.8972 7.58084C17.6201 7.30452 17.2437 7.15066 16.8524 7.15386H13.5464C13.1551 7.15066 12.7787 7.30452 12.5017 7.58084C12.2246 7.85731 12.0699 8.2331 12.0721 8.62446V9.08984H10.1659C9.45152 9.08998 8.84813 9.61979 8.75564 10.328C8.66329 11.0364 9.11063 11.7034 9.801 11.8866ZM18.7215 22.3066H11.6774C11.0408 22.3066 10.5456 21.7598 10.5456 21.0594V11.9194H19.8532V21.0594C19.8532 21.7598 19.358 22.3066 18.7215 22.3066ZM12.8167 8.62446C12.8142 8.4306 12.8904 8.24401 13.028 8.10716C13.1654 7.97031 13.3524 7.89512 13.5464 7.89847H16.8524C17.0464 7.89512 17.2334 7.97031 17.3708 8.10716C17.5084 8.24387 17.5846 8.4306 17.5822 8.62446V9.08984H12.8167V8.62446ZM10.1659 9.83445H20.2329C20.6031 9.83445 20.9031 10.1345 20.9031 10.5046C20.9031 10.8747 20.6031 11.1747 20.2329 11.1747H10.1659C9.79576 11.1747 9.49574 10.8747 9.49574 10.5046C9.49574 10.1345 9.79576 9.83445 10.1659 9.83445Z",
    fill: "#FF5252",
    stroke: "#FF5252",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCartDesktop);
export default __webpack_public_path__ + "static/media/clearCartDesktop.57e216281c9c215420fb2d40dd2c031d.svg";
export { ForwardRef as ReactComponent };